import { yupResolver } from "@hookform/resolvers/yup";
import { t } from "i18next";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useForm } from "react-hook-form";
import { Button, Input } from "ui";

import { aboutUsSchema } from "../../../helpers";
import { AboutUsFormProps, AboutUsFormValues } from "./AboutUsForm.types";

import styles from "./AboutUsForm.module.scss";

const AboutUsForm = ({
  formId,
  defaultValues,
  onSubmit,
  isLoadingUpdate
}: AboutUsFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<AboutUsFormValues>({
    defaultValues,
    resolver: yupResolver(aboutUsSchema)
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <Input
        asTag={"textarea"}
        {...register("content")}
        errorMessage={errors.content?.message}
        label={t("About Us Content")}
        placeholder={t("Enter About Us Content")}
      />

      <Button
        type="submit"
        form={formId}
        variant={"primary"}
        className={styles.form_button}
        loading={isLoadingUpdate}
      >
        {t("Save")}
      </Button>
    </form>
  );
};

export default AboutUsForm;
